<script setup lang="ts">
import type { Component } from 'vue'
import type { ArticleContent } from '~/models/Content/ArticleContent'
import { computed } from 'vue'
import { ArticleContentVariation } from '~/models/Content/ArticleContentVariation'
import ArticleTextBoxSolidLight from '~/components/article/TextBoxSolidLight.vue'
import ArticleTextBoxSolidDark from '~/components/article/TextBoxSolidDark.vue'
import ArticleTextBoxDashedLight from '~/components/article/TextBoxDashedLight.vue'
import ArticleTextBoxDashedDark from '~/components/article/TextBoxDashedDark.vue'
import ArticleText from '~/components/article/Text.vue'
import ReflectionBox from '~/components/article/ReflectionBox.vue'
import BigTextAndRoundImage from '~/components/article/BigTextAndRoundImage.vue'

const { articleContent } = defineProps<{ articleContent: ArticleContent }>()

const componentMap: Record<string, Component> = {
  [ArticleContentVariation.Text]: ArticleText,
  [ArticleContentVariation.TextAndRoundImage]: BigTextAndRoundImage,
  [ArticleContentVariation.TextOnImage]: ArticleText,
  [ArticleContentVariation.TextBoxDashedDark]: ArticleTextBoxDashedDark,
  [ArticleContentVariation.TextBoxDashedLight]: ArticleTextBoxDashedLight,
  [ArticleContentVariation.TextBoxSolidLight]: ArticleTextBoxSolidLight,
  [ArticleContentVariation.TextBoxSolidDark]: ArticleTextBoxSolidDark,
  [ArticleContentVariation.ReflectionBox]: ReflectionBox,
}

const renderedComponent = computed(() => articleContent.variation.identifier
  ? componentMap[articleContent.variation.identifier]
  : ArticleText
)
</script>

<template>
  <component
    :is="renderedComponent"
    :article-content
  />
</template>
